import { configureStore } from "@reduxjs/toolkit";

import { reducerMap } from "./reducers";
import { attachProfileBridge } from "./profileBridge";
import { ordersApi } from "../features/orders/ordersApi";
import { attachOrdersCache } from "../features/orders/ordersCache";
import { notificationsApi } from "../features/notifications/notificationsApi";
import { homeApi } from "../features/home/homeApi";

export const store = configureStore({
  reducer: {
    ...reducerMap,
    [ordersApi.reducerPath]: ordersApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [homeApi.reducerPath]: homeApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      ordersApi.middleware,
      notificationsApi.middleware,
      homeApi.middleware
    ),
});

attachProfileBridge(store);
attachOrdersCache(store);
